import { render, staticRenderFns } from "./PwaApcnContent.vue?vue&type=template&id=996782bc&"
import script from "./PwaApcnContent.vue?vue&type=script&lang=js&"
export * from "./PwaApcnContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports